<template>
  <div class="cu-select">
    <el-popover
        style="flex: 1; min-width: 0;"
        @show="show"
        @hide="hide"
        ref="cuSelectPopover"
        placement="bottom"
        trigger="click"
        popper-class="cu-popover"
        :visible-arrow="false">
      <div class="cu-input" slot="reference">
        <div :class="getLabel(value)  ? '' :'placeholder'" :style="width">{{ getLabel(value)  ? getLabel(value) : placeholder }}</div>
        <div>
          <svg-icon :icon-class="icon" class="icon"/>
        </div>
      </div>
      <div class="cu-options">
        <div v-for="(item, idx) in options" :key="item.value" :class="value ==   item.value ? 'item active' : 'item'" @click="selectEvent(item)">
          {{ item.label }}
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "customSelect",
  props:{
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    width: {
      type: String,
      default: "width: fit-content"
    },
    options: {
      type: Array,
      default: ()=>{}
    },
  },
  data(){
    return {
      icon: "bottom"
    }
  },
  computed:{
    getLabel(){
      return (value)=>{
        let res = ""
        for (let i=0; i< this.options.length; i++){
          if(this.options[i].value == value){
            res = this.options[i].label
            break
          }
        }
        return res
      }
    }
  },
  methods: {
    selectEvent(item){
      this.$refs.cuSelectPopover.doClose()
      if(this.value != item.value){
        this.$emit("input", item.value)
        this.$emit("change", item.value)
      }
    },
    hide(){
      this.icon = "bottom"
      this.$emit("visible-change")
    },
    show(){
      this.icon = "top"
      this.$emit("visible-change")
    }
  }
}
</script>

<style scoped lang="less">
.cu-select{

  .cu-input{
    width: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    white-space: nowrap;

    font-size: 14px;
    line-height: 22px;

    .placeholder{
      color: rgba(0,0,0,0.25);
    }

    .icon{
      margin-left: 4px;
      width: 9px;
      height: 9px;
    }
  }
}

</style>

<style lang="less">

.cu-popover{
  min-width: 0;
  padding: 0 4px 4px 4px;
  border: none;
  .cu-options{
    .item{
      height: 34px;
      border-radius: 6px;
      white-space: nowrap;
      line-height: 34px;
      min-width: 102px;
      padding: 0 16px;
      box-sizing: border-box;
      cursor: pointer;
      margin-top: 4px;
    }
    .item:hover{
      background: rgba(51, 113, 255, .08);
    }
    .active{
      background: rgba(51, 113, 255, .08);
    }
  }
}
</style>